/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var DangerTriangle = createReactComponent("danger-triangle", "DangerTriangle", [["path", { "d": "M12 8.5V14m0 3.247v-.5m-6.02-5.985C8.608 5.587 9.92 3 12 3c2.08 0 3.393 2.587 6.02 7.762l.327.644c2.182 4.3 3.274 6.45 2.287 8.022C19.648 21 17.208 21 12.327 21h-.654c-4.88 0-7.321 0-8.307-1.572-.987-1.572.105-3.722 2.287-8.022z", "key": "svg-0" }]]);

export { DangerTriangle as default };
//# sourceMappingURL=DangerTriangle.js.map
